import BcomPriceParser from '@nuxt-common/media-card-large/app/modules/price/parsers/PriceParser.bcom';
import McomPriceParser from '@nuxt-common/media-card-large/app/modules/price/parsers/PriceParser';

import { useBrand } from '~/composables/useBrand';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

function getKillswitches() {
  const { killswitches } = useKillswitches();
  const {
    isConsolidatedPhase3Enabled,
    isColorwayPromosEnabled,
    ccfpEnabled,
    klarnaPaymentEnabled,
    isConsolidatedMasterPageEnabled,
    isBigTicketHideInStockOfferFeatureEnabled,
    isUpcLevelPromoBadgingEnabled,
  } = killswitches;

  return {
    isConsolidatedPhase3Enabled,
    isColorwayPromosEnabled,
    ccfpEnabled,
    klarnaPaymentEnabled,
    isConsolidatedMasterPageEnabled,
    isBigTicketHideInStockOfferFeatureEnabled,
    isUpcLevelPromoBadgingEnabled,
  };
}

/**
 *  price parser parity between mcom / bcom
 */
export function usePriceParser(product: Product) {
  const { isMcom } = useBrand();
  const killswitches = getKillswitches();
  const priceOpts = { iShip: !!useFeatureEligibility()?.isInternationalMode };

  const priceParser = isMcom ? McomPriceParser : BcomPriceParser;

  return priceParser(product, killswitches, priceOpts);
}

export default usePriceParser;
